/* Rebelly tote-kampanj v2 (draft-tema): haller varukorgen i synk med kampanjen
   "en Rebelly-tote pa kopet med Hostreset och prenumeration".

   Kvalificerare: rad med PACK_VARIANT_ID (Hostreset 3-fast pack) ELLER valfri
   rad med selling_plan_allocation (prenumeration via Loop).
   Antal totes = summan av antal over alla kvalificerande rader (2 pack = 2 totes,
   1 pack + 1 prenumeration = 2 totes), tak MAX_TOTES. Noll kvalificerare = ingen tote.

   Strategi:
   1) PRIMART: temats alla cart-mutationer gar via fetch (verifierat i theme.dev.js,
      enda XHR:en ar Ajaxinate/infinite scroll). Vi wrappar fetch och KEDJAR:
      nar en mutation mot /cart/(add|change|update|clear) lyckas synkar vi toten
      klart INNAN temat far se svaret. Nar temat sedan redirectar till /cart eller
      renderar drawern ar varukorgen redan komplett - en enda paint, ingen reload.
   2) FALLBACK (t.ex. back-knapp med gammalt state): synk vid sidladdning och
      uppdatera UI utan reload via stegen:
      a) no-op-dispatch av temats egna "theme:cart:update" pa en cart-rad
         (temat gor da change + omrendering med intakta event-bindningar),
      b) annars section-swap av [data-items-holder]/[data-cart-price-holder]
         fran sektionen api-cart-items (Section Rendering API),
      c) annars, ENDAST pa /cart och max en gang per 10 s (sessionStorage-vakt),
         location.reload().
   Toten laggs ALDRIG med selling plan (ren engangsrad, foljer inte med pa
   Loop-fornyelser), qty klampas till 1, allt ar try/catch-skyddat och kan
   aldrig blockera ett kop (4 s timeout pa kedjningen).
   Rollback: ta bort denna fil + script-taggen i layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__rblToteSync) return;
  window.__rblToteSync = true;

  /* ── Konfiguration ── */
  var TOTE_VARIANT_ID = 57068509593925; /* Rebelly Tote (produkt 15673065210181), enda varianten */
  var PACK_VARIANT_ID = 58748785754437; /* "3-Fast Pack"-varianten pa Fasting Mimicking Diet (8604414214469), samma som RBL_PACK_ID i snippets/product.liquid */
  var MAX_TOTES = 20;                   /* sakerhetstak: aldrig fler an sa manga totes */
  var CHAIN_TIMEOUT_MS = 4000;          /* max tid kedjningen far forsena temats svar */
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch.bind(window);
  var syncing = false;
  var syncTimer = null;

  function jsonPost(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }

  function readCart() {
    return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* Las varukorgen och gor toten ratt. Loser med { changed: bool }.
     Far ALDRIG kasta - fel ats upp och rapporteras som "inget andrat". */
  function settleTote() {
    return readCart()
      .then(function (cart) {
        /* N = summan av antal over ALLA kvalificerande rader:
           varje rad med pack-varianten + varje rad med selling plan (prenumeration).
           1 pack + 1 pren = 2 totes, 2 pack = 2 totes, 3 pren = 3 totes. */
        var wanted = 0;
        var tote = null;
        (cart.items || []).forEach(function (line) {
          if (line.variant_id === TOTE_VARIANT_ID) { tote = line; return; }
          var qty = parseInt(line.quantity, 10);
          if (!(qty > 0)) return;
          if (line.variant_id === PACK_VARIANT_ID || line.selling_plan_allocation) wanted += qty;
        });
        if (wanted > MAX_TOTES) wanted = MAX_TOTES; /* sakerhetstak mot skenande antal */

        if (wanted === 0) {
          if (!tote) return { changed: false };
          return jsonPost('/cart/change.js', { id: tote.key, quantity: 0 })
            .then(function (r) { return { changed: r.ok }; });
        }
        if (!tote) {
          /* engangsrad: ingen selling plan -> foljer aldrig med pa Loop-fornyelser */
          return jsonPost('/cart/add.js', { items: [{ id: TOTE_VARIANT_ID, quantity: wanted, properties: { _pa_kopet: '1' } }] })
            .then(function (r) { return { changed: r.ok }; });
        }
        if (tote.quantity !== wanted) {
          /* klampar bade upp och ner till exakt N */
          return jsonPost('/cart/change.js', { id: tote.key, quantity: wanted })
            .then(function (r) { return { changed: r.ok }; });
        }
        return { changed: false };
      })
      .catch(function () { return { changed: false }; });
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (resolve) { setTimeout(function () { resolve({ changed: false }); }, ms); })
    ]);
  }

  /* ── 1) PRIMART: kedja temats cart-mutationer ── */
  try {
    window.fetch = function () {
      var arg = arguments[0];
      var url = (arg && arg.url) ? arg.url : arg;
      var isCartMutation = false;
      try { isCartMutation = typeof url === 'string' && CART_RE.test(url); } catch (e) {}
      var p = origFetch.apply(window, arguments);
      if (!isCartMutation) return p;
      return p.then(function (res) {
        if (!res || !res.ok || syncing) return res;
        syncing = true;
        return withTimeout(settleTote(), CHAIN_TIMEOUT_MS)
          .catch(function () {})
          .then(function () { syncing = false; return res; });
      });
    };
  } catch (e) {}

  /* Backstop for eventuell XHR-baserad cart-mutation (finns ingen i temat idag) */
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_RE.test(url)) {
          this.addEventListener('loadend', scheduleFallback);
        }
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  } catch (e) {}

  /* ── 2) FALLBACK vid sidladdning: synka + uppdatera UI utan reload ── */

  function refreshUiViaThemeDispatch() {
    /* No-op-andring via temats eget flode: lyssnaren pa varje cart-rad kor
       updateCart({id, quantity}) -> change + getCart + build + cartEvents.
       Samma qty = ofarlig andring, men ger en fullstandig omrendering. */
    try {
      var item = document.querySelector('[data-cart-item][data-item][data-item-index]');
      if (!item) return false;
      var key = item.getAttribute('data-item');
      var qtyInput = item.querySelector('input[name^="updates"], input[type="number"], [data-quantity-field]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
      if (!key || !(qty > 0)) return false;
      item.dispatchEvent(new CustomEvent('theme:cart:update', { detail: { id: key, quantity: qty }, bubbles: true }));
      return true;
    } catch (e) { return false; }
  }

  function refreshUiViaSectionSwap() {
    /* Section Rendering API: samma sektion som temat sjalvt anvander (api-cart-items). */
    var itemsHolder = document.querySelector('[data-items-holder]');
    var priceHolder = document.querySelector('[data-cart-price-holder]');
    if (!itemsHolder && !priceHolder) return Promise.resolve(false);
    return origFetch('/cart?section_id=api-cart-items', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var api = tmp.querySelector('[data-api-content]');
        if (!api) return false;
        var lines = api.querySelector('[data-api-line-items]');
        var price = api.querySelector('[data-api-cart-price]');
        if (itemsHolder) itemsHolder.innerHTML = lines ? lines.innerHTML : '';
        if (priceHolder && price) priceHolder.innerHTML = price.innerHTML;
        return true;
      })
      .catch(function () { return false; });
  }

  function guardedReload() {
    /* Sista utvag, bara pa /cart och max en gang per 10 s. */
    try {
      if (!/^\/cart(\/|$)/.test(window.location.pathname)) return;
      var last = parseInt(sessionStorage.getItem('rblToteReload') || '0', 10);
      if (Date.now() - last < 10000) return;
      sessionStorage.setItem('rblToteReload', String(Date.now()));
      window.location.reload();
    } catch (e) {}
  }

  function fallbackSync() {
    if (syncing) return;
    syncing = true;
    settleTote()
      .then(function (result) {
        syncing = false;
        if (!result || !result.changed) return;
        if (refreshUiViaThemeDispatch()) return;
        return refreshUiViaSectionSwap().then(function (swapped) {
          if (!swapped) guardedReload();
        });
      })
      .catch(function () { syncing = false; });
  }

  function scheduleFallback() {
    try {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(fallbackSync, 700);
    } catch (e) {}
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { fallbackSync(); });
    } else {
      fallbackSync();
    }
    window.addEventListener('pageshow', function (ev) { if (ev && ev.persisted) fallbackSync(); });
  } catch (e) {}
})();
